import { render, staticRenderFns } from "./kafpos-form.vue?vue&type=template&id=5cef4610&lang=pug"
import script from "./kafpos-form.vue?vue&type=script&setup=true&lang=js"
export * from "./kafpos-form.vue?vue&type=script&setup=true&lang=js"
import style0 from "@ui-common/vue-spinner/dist/vue-spinner.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports